import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { client } from './client';
import { ThemeProvider, CSSReset } from '@chakra-ui/react';
import { extendTheme } from '@chakra-ui/react';
import defaultTheme from './default-theme';
import { IntlProvider } from 'react-intl';
import trEn from '../i18n/react-intl/en.json';
import trEs from '../i18n/react-intl/es.json';
import trIt from '../i18n/react-intl/it.json';
import trFr from '../i18n/react-intl/fr.json';

export const wrapRootElement = ({ element }) => {
  let theme = {};
  const messages = {
    es: trEs,
    en: trEn,
    it: trIt,
    fr: trFr,
  };
  let translation = {};

  try {
    theme = extendTheme(JSON.parse(process.env.THEME_CONFIG));
    theme = extendTheme(defaultTheme);
  } catch (error) {
    theme = extendTheme(defaultTheme);
  }
  const locale = process.env.LOCALE === 'undefined' ? 'en' : process.env.LOCALE;

  //Use custom translation if its available
  try {
    if (process.env.TRANSLATION === '') {
      translation = messages[locale];
    } else {
      translation = JSON.parse(process.env.TRANSLATION);
    }
  } catch (error) {
    translation = messages[locale];
  }

  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <IntlProvider defaultLocale="en" locale={locale} messages={translation}>
          {element}
        </IntlProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};
